import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Moon, User, Loader2 } from 'lucide-react';
import { api } from '@/lib/api';
import { useAuth } from '@/hooks/useAuth';

export default function Login() {
  const navigate = useNavigate();
  const { setAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [identifier, setIdentifier] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.login({ identifier });
      if (response.success && response.data) {
        setAuth(response.data.contestant, response.data.token);
        navigate('/competition');
      } else {
        setError(response.error || 'حدث خطأ أثناء تسجيل الدخول');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'لم يتم العثور على حساب بهذه البيانات');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <Link to="/">
            <Moon className="w-12 h-12 text-gold-500 mx-auto mb-4" />
          </Link>
          <h1 className="text-3xl font-amiri font-bold text-gold-500 mb-2">
            تسجيل الدخول
          </h1>
          <p className="text-gray-400">
            أدخل بريدك الإلكتروني أو رقم هاتفك للدخول
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="card space-y-6">
          {error && (
            <div className="bg-red-500/10 border border-red-500/50 rounded-lg p-4 text-red-400 text-center">
              {error}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              البريد الإلكتروني أو رقم الهاتف
            </label>
            <div className="relative">
              <User className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
              <input
                type="text"
                required
                className="input-field pr-10"
                placeholder="example@email.com أو 05XXXXXXXX"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
              />
            </div>
            <p className="mt-2 text-sm text-gray-500">
              استخدم نفس البريد أو رقم الهاتف الذي سجلت به
            </p>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                جاري الدخول...
              </>
            ) : (
              'دخول'
            )}
          </button>

          <div className="text-center space-y-2">
            <p className="text-gray-400">
              ليس لديك حساب؟{' '}
              <Link to="/register" className="text-gold-500 hover:text-gold-400">
                سجل الآن
              </Link>
            </p>
            <Link to="/" className="text-gray-500 hover:text-gray-400 text-sm block">
              العودة للصفحة الرئيسية
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
